import './DashboardStyle.css'
import { useSidebar } from '../../SidebarContext';
import AddButtonsDashboard from './AddButtonsDashboard';
import UserDetailDashboard from './UserDetailDashboard';
import InvoiceDashboard from './InvoiceDashboard';
import OrderDashboard from './OrderDashboard';
import ExpenseDashboard from './ExpenseDashboard';
import RecentTransactions from './RecentTransaction';
import InfoDashboard from './InfoDashboard';
import { useEffect, useState } from 'react';
import Loader from '../Loader';
import OrderCharts from '../OtherCarts/OrderCharts';

const Dashboard = () => {
    const { isSidebarOpen } = useSidebar();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // simulate wait for all child components to load (or use real data checks)
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000); // 1s simulated load (replace with real checks later)

        return () => clearTimeout(timer);
    }, []);

    if (loading) {
        return (
            <Loader />
        );
    }

    return (
        <>
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <UserDetailDashboard />
                <AddButtonsDashboard />

                <OrderCharts />
                {/* <div className="dashboard-row-flex">
                    <div className="dashboard-invoice-flex">
                        
                    </div>
                    <div className="dashboard-order-flex">
                        <OrderDashboard />
                    </div>
                </div> */}
                <InfoDashboard />
                <InvoiceDashboard />
                <div className="dashboard-row-flex">
                    <div className="dashboard-order-flex">
                        <ExpenseDashboard />
                    </div>
                    <div className="dashboard-invoice-flex">
                        <RecentTransactions />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Dashboard;